/**
 * Дизайн-токены. Фаза 4: расширенная палитра, typography scale, shadows, easing.
 */
export const tokens = {
  color: {
    // Существующие (не меняем — CSS уже использует через алиасы)
    cream: "#fff3d8",
    paper: "#fff8e7",
    teal: "#1f7e86",
    tealSoft: "#3aa3ad",
    sky: "#2b879f",
    gold: "#d4a64a",
    honey: "#f0c161",
    shadow: "#1a3340",
    night: "#162834",
    deepNight: "#0d1c25",
    leaf: "#3f8a5b",
    mint: "#9fd3a8",
    rose: "#e89aa8",
    white: "#ffffff",
    // Новые — для редизайна фазы 4
    cyanMist: "#a8d8e5",
    amberWarm: "#ffb87a",
    petal: "#f9c6d1",
    nightDeep: "#091721",
    inkSoft: "#cae3e8",
    glassMembrane: "rgba(255, 243, 216, 0.08)",
  },
  typography: {
    fontFamily: {
      display: '"Fraunces Variable", "Fraunces", Georgia, "Times New Roman", serif',
      ui: 'ui-rounded, "Nunito", system-ui, -apple-system, sans-serif',
      mono: 'ui-monospace, "SF Mono", Menlo, monospace',
    },
    scale: {
      display: {
        size: "clamp(2.4rem, 8vw, 3.6rem)",
        lineHeight: 1.1,
        weight: 600,
        letterSpacing: "-0.01em",
      },
      h1: {
        size: "clamp(1.6rem, 5vw, 2.2rem)",
        lineHeight: 1.2,
        weight: 600,
        letterSpacing: "0em",
      },
      h2: { size: "1.25rem", lineHeight: 1.3, weight: 600, letterSpacing: "0em" },
      body: { size: "1rem", lineHeight: 1.55, weight: 400, letterSpacing: "0em" },
      caption: { size: "0.875rem", lineHeight: 1.4, weight: 400, letterSpacing: "0.01em" },
      micro: { size: "0.75rem", lineHeight: 1.3, weight: 500, letterSpacing: "0.04em" },
    },
  },
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 40, xxl: 64 },
  radius: { sm: 6, md: 14, lg: 24, xl: 36, full: 9999 },
  shadows: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.18)",
    md: "0 4px 12px rgba(0, 0, 0, 0.22), 0 1px 3px rgba(0, 0, 0, 0.12)",
    lg: "0 12px 32px rgba(0, 0, 0, 0.32), 0 4px 12px rgba(0, 0, 0, 0.18)",
    glow: "0 0 32px rgba(168, 216, 229, 0.45), 0 0 64px rgba(168, 216, 229, 0.18)",
    inset: "inset 0 1px 0 rgba(255, 255, 255, 0.05)",
  },
  motion: {
    instant: 0,
    fast: 140,
    normal: 220,
    slow: 400,
    cinematic: 720,
  },
  easing: {
    standard: "cubic-bezier(0.4, 0, 0.2, 1)",
    emphasized: "cubic-bezier(0.2, 0, 0, 1)",
    decelerate: "cubic-bezier(0, 0, 0.2, 1)",
    accelerate: "cubic-bezier(0.4, 0, 1, 1)",
    spring: "cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
} as const;

export type ColorToken = keyof typeof tokens.color;
